<div class="padding flex column fix-width">
	<h4 class="bold margin-bottom-small">{{ isEdit ? 'Edit user role' : 'Add user role' }}</h4>

	<div class="flex column">
		<div class="flex center">
			<b>User profile</b>
			@if (!validation.userProfileId) {
				<span class="red margin-left">Required field</span>
			}
		</div>
		<mat-select
			[(value)]="selectedUserProfileId"
			class="margin-top-smallest margin-bottom full-width"
			placeholder="Select a user profile"
			[disabled]="loading || isEdit"
			(selectionChange)="onUserProfileChange()"
		>
			@for (userProfile of userProfiles; track userProfile.id) {
				<mat-option [value]="userProfile.id">{{ userProfile.name }}</mat-option>
			}
		</mat-select>

		<div class="flex center">
			<b>Role</b>
			@if (!validation.roleId) {
				<span class="red margin-left">Required field</span>
			}
		</div>
		<mat-select
			[(value)]="selectedRoleId"
			class="margin-top-smallest full-width"
			placeholder="Select a role"
			[disabled]="loading"
			(selectionChange)="onRoleChange()"
		>
			@for (role of roles; track role.id) {
				<mat-option [value]="role.id">{{ role.name | role }}</mat-option>
			}
		</mat-select>
	</div>

	<div class="flex column end margin-top">
		<div class="flex center">
			<button class="stroked margin-right-small" (click)="close()">
				<i class="fa-solid fa-undo"></i>
				Discard
			</button>
			<button (click)="apply()" [disabled]="loading">
				<i class="fa-solid fa-check"></i>
				Apply
			</button>
		</div>
	</div>
</div>
